import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import * as Sentry from '@sentry/browser';
import { availableLanguages, defaultLang } from './helpers/constants';

i18n.on('languageChanged', (lng) => {
  Sentry.addBreadcrumb({
    category: 'localization',
    message: `Language was changed to ${lng}`,
    level: 'info',
  });

  Sentry.setTag('lng', lng);
});

i18n.on('initialized', () => {
  Sentry.addBreadcrumb({
    category: 'localization',
    message: `Localization was initialized`,
    level: 'info',
  });
});

i18n.on('failedLoading', (lng, ns, msg) => {
  Sentry.captureMessage(
    `Failed to load i18n resource ${lng}.${ns}\nMsg: ${msg}`,
    'warning'
  );
});

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: process.env.REACT_APP_ENV !== 'production',

    fallbackLng: defaultLang,
    supportedLngs: availableLanguages,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`,
      queryStringParams: {
        v:
          process.env.NODE_ENV === 'production'
            ? process.env.BUILD_VERSION
            : 'dev',
      },
    },

    detection: {
      order: ['path', 'querystring'],
    },
  });

export default i18n;
